import { render, staticRenderFns } from "./t-app-menu-right-button.vue?vue&type=template&id=77a1895e&scoped=true&"
import script from "./t-app-menu-right-button.vue?vue&type=script&lang=js&"
export * from "./t-app-menu-right-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a1895e",
  null
  
)

export default component.exports